const formatMoney = (value) =>
  `$ ${Number(value || 0).toLocaleString("en-US", {
    maximumFractionDigits: 2,
  })}`;

const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        sorter:true,
        // sorter: (a, b) => a?.name?.localeCompare(b?.name),
    },
    {
        title: 'Mobile No.',
        dataIndex: 'phoneNo',
        sorter:true,
        // sorter: (a, b) => a?.phoneNo?.localeCompare(b?.phoneNo),
    },
    {
        title: 'Request Date',
        dataIndex: 'requestDate',
        sorter:true,
        // sorter: (a, b) => new Date(a.requestDate) - new Date(b.requestDate),
    },
    {
        title: 'Approved Date',
        dataIndex: 'actionDate',
        sorter:true,
        // sorter: (a, b) => new Date(a.actionDate) - new Date(b.actionDate),
    },
    {
        title: 'Action By',
        dataIndex: 'actionBy',
        sorter:true,
    },
    {
        title: 'Total Deposit',
        dataIndex: 'totalDeposit',
        render: (value) => formatMoney(value),
    },
    {
        title: 'Total Withdrawal',
        dataIndex: 'totalWithdrawal',
        render: (value) => formatMoney(value),
    },
    {
        title: 'Net Deposit',
        dataIndex: 'netDeposit',
        render: (_, record) =>
            formatMoney(
                Number(record?.totalDeposit || 0) -
                    Number(record?.totalWithdrawal || 0),
            ),
    },
    {
        title: 'Actions',
        dataIndex: 'action'
    }
];

export default columns;